/**
 * assets/js/src/thankyou-game.js -- hra „had sbira poklady" na dekovne strance.
 *
 * PORT ZE STARE SABLONY BEZE ZMENY LOGIKY (plan 18-03). Zdroj:
 * `wp-content-theme/terrahunt/assets/js/thankyou-game.js` (133 radku,
 * prenesen 19. 8. 2026). Herni engine, ovladani, plural i chovani
 * fullscreenu jsou BAJTOVE tytez -- jedine, co se zmenilo, je cesta
 * souboru a to, ze se bunduje vlastnim esbuild vstupem
 * (`build:js:thankyou-game`) a enqueue-uje se JEN na dekovnych strankach,
 * ne globalne v `index.js`.
 *
 * Puvodni docblok zdroje zustava nize beze zmeny.
 */
(function(){
  var c = document.getElementById('thn-canvas'); if (!c) return;
  // defaults per-klíč: i kdyby inline i18n chyběl nebo byl neúplný, hra
  // nespadne na undefined (external review 19. 8.)
  var DEF = {
    collected: { one:'Nasbírali jste 1 poklad', few:'Nasbírali jste %d poklady', many:'Nasbírali jste %d pokladů' },
    retry:  'Zkuste to znovu, než se ozveme',
    shrink: 'Zmenšit',
    expand: 'Zvětšit na celou obrazovku'
  };
  var EXT = window.thnGameI18n || {};
  var I = {
    collected: Object.assign({}, DEF.collected, EXT.collected || {}),
    retry:  EXT.retry  || DEF.retry,
    shrink: EXT.shrink || DEF.shrink,
    expand: EXT.expand || DEF.expand
  };
  function collectedText(n){
    var t = (n === 1) ? I.collected.one : (n >= 2 && n <= 4 ? I.collected.few : I.collected.many);
    return t.replace('%d', n);
  }
  var ctx = c.getContext('2d'), CELL = 20, COLS = 0, ROWS = 11;
  var snake, dir, next, treasures, score, alive, timer;
  var wrap = document.querySelector('.thn-game');
  function big(){ return document.fullscreenElement === wrap || wrap.classList.contains('thn-lb'); }
  function fit(){
    // ve zvětšeném režimu se počítá i s dostupnou VÝŠKOU, jinak drží 11 řádků
    var w = c.parentElement.clientWidth;
    var cell = big() ? 30 : CELL;
    COLS = Math.max(12, Math.floor(w / cell));
    ROWS = big() ? Math.max(9, Math.floor(c.clientHeight / cell)) : 11;
    c.width = COLS*cell; c.height = ROWS*cell;
    if (!big()) c.style.height = (ROWS*cell)+'px';
    CELLNOW = cell;
  }
  var CELLNOW = CELL;
  // po změně velikosti plochy se souřadnice zarovnají do nové mřížky,
  // ať se hráči nezmizí had mimo hřiště
  function clamp(){
    snake = snake.map(function(s){ return { x: ((s.x % COLS) + COLS) % COLS, y: ((s.y % ROWS) + ROWS) % ROWS }; });
    treasures = treasures.map(function(t){ return { x: ((t.x % COLS) + COLS) % COLS, y: ((t.y % ROWS) + ROWS) % ROWS }; });
  }
  function spawn(){ var t; do { t={x:Math.floor(Math.random()*COLS),y:Math.floor(Math.random()*ROWS)}; }
    while (snake.some(function(s){return s.x===t.x&&s.y===t.y;})); return t; }
  function reset(){ fit(); snake=[{x:3,y:5},{x:2,y:5},{x:1,y:5}]; dir={x:1,y:0}; next=dir;
    treasures=[spawn(),spawn()]; score=0; alive=true;
    document.getElementById('thn-score').textContent='0';
    if (timer) clearInterval(timer); timer=setInterval(step,130); draw(); }
  function step(){ if(!alive) return; dir=next;
    var h={x:snake[0].x+dir.x,y:snake[0].y+dir.y};
    if(h.x<0)h.x=COLS-1; if(h.x>=COLS)h.x=0; if(h.y<0)h.y=ROWS-1; if(h.y>=ROWS)h.y=0;
    if(snake.some(function(s){return s.x===h.x&&s.y===h.y;})){alive=false;draw();return;}
    snake.unshift(h);
    var hit=-1; treasures.forEach(function(t,i){ if(t.x===h.x&&t.y===h.y) hit=i; });
    if(hit>-1){treasures[hit]=spawn();score++;document.getElementById('thn-score').textContent=score;}
    else snake.pop();
    draw(); }
  function draw(){
    var CELL = CELLNOW; // ve zvětšeném režimu je buňka větší
    ctx.fillStyle='#132020'; ctx.fillRect(0,0,c.width,c.height);
    ctx.strokeStyle='rgba(255,255,255,.035)'; ctx.lineWidth=1;
    for(var x=0;x<=COLS;x++){ctx.beginPath();ctx.moveTo(x*CELL,0);ctx.lineTo(x*CELL,c.height);ctx.stroke();}
    for(var y=0;y<=ROWS;y++){ctx.beginPath();ctx.moveTo(0,y*CELL);ctx.lineTo(c.width,y*CELL);ctx.stroke();}
    treasures.forEach(function(t){ var cx=t.x*CELL+CELL/2, cy=t.y*CELL+CELL/2;
      ctx.beginPath();ctx.arc(cx,cy,CELL*0.55,0,6.284);ctx.fillStyle='rgba(245,166,7,.18)';ctx.fill();
      ctx.beginPath();ctx.arc(cx,cy,CELL*0.3,0,6.284);ctx.fillStyle='#F5A607';ctx.fill(); });
    snake.forEach(function(s,i){ var pad=i===0?2:3, r=5, x=s.x*CELL+pad, y=s.y*CELL+pad, w=CELL-pad*2, hh=CELL-pad*2;
      ctx.fillStyle = i===0 ? '#00E0FA' : 'rgba(0,183,205,'+Math.max(.25,1-i/snake.length)+')';
      ctx.beginPath();ctx.moveTo(x+r,y);ctx.arcTo(x+w,y,x+w,y+hh,r);ctx.arcTo(x+w,y+hh,x,y+hh,r);
      ctx.arcTo(x,y+hh,x,y,r);ctx.arcTo(x,y,x+w,y,r);ctx.closePath();ctx.fill(); });
    if(!alive){ ctx.fillStyle='rgba(10,18,18,.8)'; ctx.fillRect(0,0,c.width,c.height);
      ctx.textAlign='center'; ctx.fillStyle='#fff';
      ctx.font='700 19px -apple-system,Segoe UI,Roboto,sans-serif';
      ctx.fillText(collectedText(score), c.width/2, c.height/2-4);
      ctx.fillStyle='#7fe3f0'; ctx.font='14px -apple-system,Segoe UI,Roboto,sans-serif';
      ctx.fillText(I.retry, c.width/2, c.height/2+20); } }
  var K={ArrowUp:{x:0,y:-1},ArrowDown:{x:0,y:1},ArrowLeft:{x:-1,y:0},ArrowRight:{x:1,y:0},
         w:{x:0,y:-1},s:{x:0,y:1},a:{x:-1,y:0},d:{x:1,y:0}};
  // klávesy chytá jen fokusovaný canvas (tabindex=0 v šabloně), ne document
  // -- globální preventDefault bral šipkám scroll celé stránky a WASD polím
  // (shoda všech reviewerů 19. 8.). Modifikátory (Cmd+A, Alt+šipka) projdou.
  c.addEventListener('keydown',function(e){ if(e.ctrlKey||e.metaKey||e.altKey) return;
    var d=K[e.key]; if(!d) return;
    if(d.x===-dir.x&&d.y===-dir.y){ e.preventDefault(); return; } next=d; e.preventDefault(); });
  c.addEventListener('pointerdown',function(){ c.focus(); });
  var t0=null;
  c.addEventListener('touchstart',function(e){t0=e.touches[0];},{passive:true});
  c.addEventListener('touchend',function(e){ if(!t0) return;
    var dx=e.changedTouches[0].clientX-t0.clientX, dy=e.changedTouches[0].clientY-t0.clientY;
    var d=Math.abs(dx)>Math.abs(dy)?{x:dx>0?1:-1,y:0}:{x:0,y:dy>0?1:-1};
    if(!(d.x===-dir.x&&d.y===-dir.y)) next=d; t0=null; },{passive:true});
  document.getElementById('thn-restart').addEventListener('click',function(e){ e.preventDefault(); reset(); c.focus(); });
  // hra na pozadí netopí baterku: skrytý tab interval zastaví, návrat obnoví
  document.addEventListener('visibilitychange',function(){
    if(document.hidden){ if(timer){ clearInterval(timer); timer=null; } }
    else if(alive && !timer){ timer=setInterval(step,130); } });

  function relayout(){ fit(); clamp(); draw(); syncBtn(); }
  function openLightbox(){ wrap.classList.add('thn-lb'); document.body.classList.add('thn-lb-open'); setTimeout(relayout, 30); }
  function closeLightbox(){ wrap.classList.remove('thn-lb'); document.body.classList.remove('thn-lb-open'); setTimeout(relayout, 30); }

  var fullBtn = document.getElementById('thn-full');
  // popisek se řídí stavem: zvětšeno -> „Zmenšit"
  function syncBtn(){ fullBtn.textContent = big() ? I.shrink : I.expand; }

  fullBtn.addEventListener('click', function(){
    if (big()) {                                  // zmenšit
      if (document.fullscreenElement === wrap && document.exitFullscreen) document.exitFullscreen();
      else closeLightbox();
      return;
    }
    if (wrap.requestFullscreen) {                 // zvětšit
      wrap.requestFullscreen().then(function(){ setTimeout(relayout, 60); })
        .catch(openLightbox);   // odmítnuto (např. iframe bez povolení) -> lightbox
    } else {
      openLightbox();           // iOS Safari fullscreen na prvku neumí
    }
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && wrap.classList.contains('thn-lb')) closeLightbox();
  });
  document.addEventListener('fullscreenchange', function(){ setTimeout(relayout, 60); });
  window.addEventListener('resize', relayout);
  syncBtn();
  reset();
})();
